/**
 * API Endpoints Configuration
 * Centralized API routes for the LMS application
 */

const API_PREFIX = '';

export const ENDPOINTS = {
  // ================== AUTHENTICATION ==================
  AUTH: {
    LOGIN: `${API_PREFIX}auth/login`,
    LOGOUT: `${API_PREFIX}auth/logout`,
    REFRESH: `${API_PREFIX}auth/refresh`,
  },

  // ================== ACTIVE SESSIONS ==================
  SESSIONS: {
    BASE: `${API_PREFIX}me/sessions`,
    BY_ID: (sessionId) => `${API_PREFIX}me/sessions/${sessionId}`,
  },

  // ================== PASSWORD ==================
  PASSWORD: {
    RESET_REQUEST: `${API_PREFIX}password/reset/request`,
    RESET_CONFIRM: `${API_PREFIX}password/reset/confirm`,
    CHANGE: `${API_PREFIX}password/change-password`,
  },

  // ================== ADMIN ==================
  ADMIN: {
    DASHBOARD: `${API_PREFIX}admin/dashboard`,
    COURSE: `${API_PREFIX}admin/course`,
    GROUP: `${API_PREFIX}admin/group`,
    LESSON: `${API_PREFIX}admin/lesson`,
    USER: `${API_PREFIX}admin/user`,
    UPDATE: `${API_PREFIX}admin/update`,
    ROOM: `${API_PREFIX}admin/room`,
  },

  // ================== TEACHER ==================
  TEACHER: {
    BASE: `${API_PREFIX}teacher`,
    DASHBOARD: `${API_PREFIX}teacher/dashboard`,
    GROUP: `${API_PREFIX}teacher/group`,
    LESSON: `${API_PREFIX}teacher/lesson`,
    TASK: `${API_PREFIX}teacher/task`,
    HOMEWORK: `${API_PREFIX}teacher/homework`,
    COURSE_ID: `${API_PREFIX}teacher/course-id`,
  },

  // ================== STUDENT ==================
  STUDENT: {
    BASE: `${API_PREFIX}student`,
    DASHBOARD: `${API_PREFIX}student/dashboard`,
    GROUP: `${API_PREFIX}student/group`,
    LESSON: `${API_PREFIX}student/lesson`,
    HOMEWORK: `${API_PREFIX}student/homework`,
    HOMEWORK_NOTIFICATION: `${API_PREFIX}student/homework/notification`,
    HOMEWORK_RECENT_GRADES: `${API_PREFIX}student/homework/recent-grades`,
  },

  // ================== MESSAGING ==================
  MESSAGING: {
    CONVERSATION: `${API_PREFIX}conversation`,
    MESSAGES: `${API_PREFIX}messages`,
    MESSAGES_UNREAD_COUNT: `${API_PREFIX}direct-messages/unread/count`,
    MESSAGES_DIRECT: `${API_PREFIX}direct-messages/direct`,
    MESSAGES_ROOM: `${API_PREFIX}messages/room`,
  },

  // ================== SHARED ==================
  SHARED: {
    DOWNLOAD: `${API_PREFIX}download`,
    USER_INFO: `${API_PREFIX}user-info`,
  },

  PUSH: {
    VAPID_KEY: `${API_PREFIX}user/push/vapid-key`,
    SUBSCRIBE: `${API_PREFIX}user/push/subscribe`,
    UNSUBSCRIBE: `${API_PREFIX}user/push/unsubscribe`,
  },
};

export default ENDPOINTS;

